module.exports = __webpack_public_path__ + "img/Compact-SR_Overview-ECC_1.a04d6349.jpg";